import { render, staticRenderFns } from "./hsa-settings.component.vue?vue&type=template&id=39c40b58&"
import script from "./hsa-settings.component.vue?vue&type=script&lang=ts&"
export * from "./hsa-settings.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports